export enum CustomerType {
  Private = "PRIVATE",
  Company = "COMPANY",
}

export const mapToCustomerTypeEnum = (
  customerType: string,
): CustomerType | undefined => {
  switch (customerType) {
    case "Kunde_B2C":
      return CustomerType.Private;
    case "Kunde_B2B":
      return CustomerType.Company;
    default:
      return undefined;
  }
};
